import React, { useState, useEffect } from "react";
import axios from "axios";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Modal from "react-modal";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const SalesOrderDeliveryChallanItemEdit = () => {
  const [formData, setFormData] = useState({});
  const [oldQuantities, setOldQuantities] = useState(0); // State to maintain old quantities
  const [isVisible, setIsVisible] = useState(true);
  const { id, customer_id, salesId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const code = location.state?.code;
  const is_delivery_challan = location.state?.is_delivery_challan;

  const token = sessionStorage.getItem("token");
  const headers = { headers: { Authorization: `Bearer ${token}` } };

  const [erpList, setErpList] = useState([]);
  useEffect(() => {
    const storedErpList = sessionStorage.getItem("erplist");
    if (storedErpList) {
      try {
        const parsedErpList = JSON.parse(storedErpList);
        setErpList(parsedErpList);
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
    }
  }, []);

  const showActionColumn = erpList.some(
    (item) => item.erp_module_id === 24 && item.update
  );

  useEffect(() => {
    getSalesOrderItem();
  }, []);

  const getSalesOrderItem = () => {
    axios
      .post("/api/purple-fusion/salesorderitem/get/dc/items", { id }, headers)
      .then((response) => {
        const data = response.data;
        console.log(response.data);

        // Populate oldQuantities with the initial quantities
        const initialQuantities = data.salesOrderItems[0].quantity;
        setOldQuantities(initialQuantities);
        data.salesOrderItems.forEach((item) => {
          item.quantity = 0; // Initialize the quantity to 0
        });
        setFormData(data);
      })
      .catch((error) => {
        console.error("Error fetching Sales Order data:", error);
      });
  };

  const handleQuantityChange = (e, deliveryChallanItemId) => {
    const updatedData = { ...formData };
    const value = e.target.value.trim();
    const newQuantity = parseFloat(value);

    if (value === "" || !isNaN(newQuantity)) {
      const itemIndex = updatedData.deliveryChallanItems.findIndex(
        (item) => item.delivery_challan_item_id === deliveryChallanItemId
      );

      if (itemIndex !== -1) {
        updatedData.deliveryChallanItems[itemIndex].quantity = isNaN(
          newQuantity
        )
          ? ""
          : newQuantity;

        // Calculate the total quantity based on the new quantities
        const totalQuantity = updatedData.deliveryChallanItems
          .filter((item) => item.isactive)
          .reduce((sum, item) => sum + item.quantity || 0, 0);
        updatedData.salesOrderItems[0].quantity = totalQuantity;

        setFormData(updatedData);
      }
    } else {
      console.error("Invalid quantity input");
    }
  };

  const handleCheckboxToggle = (deliveryChallanItemId) => {
    const updatedData = { ...formData };

    // Find the item by deliveryChallanItemId
    const itemIndex = updatedData.deliveryChallanItems.findIndex(
      (item) => item.delivery_challan_item_id === deliveryChallanItemId
    );

    if (itemIndex !== -1) {
      updatedData.deliveryChallanItems[itemIndex].isactive =
        !updatedData.deliveryChallanItems[itemIndex].isactive;

      // Calculate the total quantity for the salesOrderItem based on deliveryChallanItems quantities
      const totalQuantity = updatedData.deliveryChallanItems
        .filter((item) => item.isactive)
        .reduce((sum, item) => sum + item.quantity, 0);

      // Update the sales order item's quantity revised by the total
      updatedData.salesOrderItems[0].quantity = totalQuantity;

      // Update the state with the new data
      setFormData(updatedData);
    }
  };
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    // Filter to get only the active delivery challan items
    const activeDeliveryChallanItems = formData.deliveryChallanItems.filter(
      (item) => item.isactive
    );

    // Validation: Ensure at least one item is selected
    if (activeDeliveryChallanItems.length === 0) {
      toast.error("Please select at least one delivery challan item.", {
        autoClose: 2000,
      });
      return; // Exit the function if no items are selected
    }

    // Prepare data for submission
    const salesOrderItem = formData.salesOrderItems[0]; // Assuming there's only one sales order item
    const deliveryChallanItems = activeDeliveryChallanItems.map(
      (item) => `${item.delivery_challan_item_id}@${item.quantity}`
    );

    const dataToSubmit = {
      id: salesOrderItem.id,
      quantity: oldQuantities + salesOrderItem.quantity,
      delivery_date: salesOrderItem.delivery_date,
      isactive: salesOrderItem.isactive,
      delivery_challan_array: deliveryChallanItems,
    };

    console.log(dataToSubmit);

    // Uncomment and configure the axios call when ready to submit data to the server
    axios
      .put(
        "/api/purple-fusion/salesorderitem/update/salesorder/dc",
        dataToSubmit,
        headers
      )
      .then((response) => {
        const message = response.data.message;
        if (response.data.status) {
          toast.success(message, {
            autoClose: 2000,
            onClose: () => {
              setIsVisible(false);
              navigate(`/salesorderall/${salesId}/${customer_id}`, {
                state: {
                  code: code,
                  is_delivery_challan: is_delivery_challan,
                },
              });
            },
          });
        } else {
          toast.error(message, { autoClose: 2000 });
        }
      })
      .catch((error) => {
        console.error("Error updating Sales Order data:", error);
        setIsVisible(false);
        navigate("*");
      });
  };

  const customStyle = {
    content: {
      width: "70%",
      height: "90%",
      margin: "auto",
      borderRadius: "10px",
    },
    overlay: { backgroundColor: "rgba(0, 0, 0, 0.5)" },
  };

  return (
    <div className="bg-gray-100 min-h-screen flex items-center justify-center">
      {showActionColumn ? (
        <Modal isOpen={isVisible} style={customStyle}>
          <form onSubmit={handleFormSubmit}>
            <div className="p-3 bg-white rounded-lg shadow-lg relative">
              <button
                onClick={() => {
                  setIsVisible(false);
                  navigate(`/salesorderall/${salesId}/${customer_id}`, {
                    state: {
                      code: code,
                      is_delivery_challan: is_delivery_challan,
                    },
                  });
                }}
                type="button"
                className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
              >
                ╳
              </button>
              <button
                // onClick={handleFormSubmit}
                type="submit"
                className="absolute top-4 right-12 active:scale-90 transition-transform duration-200 text-white-A700 text-sm bg-blue-A700 text-white py-1 px-3  rounded-[7px]  hover:bg-blue-600"
              >
                Save
              </button>
              <h2 className="text-xl font-medium mb-4">
                Edit Sales Order Items
              </h2>

              <div className="space-y-2">
                <div>
                  <h3 className="text-lg font-medium mb-2">
                    Sales Order Items
                  </h3>

                  {formData?.salesOrderItems?.map((item) => (
                    <div key={item.id} className="mb-4 p-3 border rounded-lg">
                      <label className="block text-sm py-1 font-semibold text-gray-900">
                        Sales Order Code: {code}
                      </label>
                      <div className="grid grid-cols-3 gap-y-2 items-center justify-between">
                        <label className="block text-sm font-medium text-gray-900">
                          Item Name: {item.itemname}
                        </label>
                        <label className="block text-sm font-medium text-gray-900">
                          Provided Code: {item.code_op}
                        </label>
                        <label className="block text-sm font-medium text-gray-900">
                          Item Code: {item.code}
                        </label>
                        <label className="block text-sm font-semibold text-gray-900">
                          Old Quantity: {oldQuantities || 0}
                        </label>
                        <label className="block text-sm font-semibold text-gray-900">
                          New Quantity: {item.quantity}
                        </label>
                        <label className="block text-sm font-medium text-gray-900">
                          Cost Price: {item.cost_price}
                        </label>
                        <label className="block text-sm font-medium text-gray-900">
                          Item Description: {item.item_description}
                        </label>
                      </div>
                    </div>
                  ))}
                </div>
                <div>
                  <h3 className="text-lg font-medium mb-2">
                    Delivery Challan Items
                  </h3>
                  <div className="max-h-48 overflow-y-auto">
                    <table className="min-w-full bg-white text-sm border font-medium border-gray-200 ">
                      <thead className="bg-gray-400 rounded-md">
                        <tr>
                          <th className="px-4 py-2 border">Select</th>
                          <th className="px-4 py-2 border">Challan Code</th>
                          <th className="px-4 py-2 border">Item Name</th>
                          <th className="px-4 py-2 border">
                            Sales Order Moved Quantity
                          </th>
                          <th className="px-4 py-2 border">
                            Quantity Revised By
                          </th>
                          <th className="px-4 py-2 border"> Total Moved Quantity</th>
                          <th className="px-4 py-2 border">Initial Quantity</th>
                        </tr>
                      </thead>
                      <tbody>
                        {formData?.deliveryChallanItems
                          // ?.filter((item) => item.quantity > 0)
                          ?.map((item) => (
                            <tr key={item.delivery_challan_item_id}>
                              <td className="px-4 py-2 border text-center">
                                <input
                                  className="h-5 w-5 rounded"
                                  type="checkbox"
                                  checked={item.isactive}
                                  onChange={() =>
                                    handleCheckboxToggle(
                                      item.delivery_challan_item_id
                                    )
                                  }
                                />
                              </td>
                              <td className="px-4 py-2 border">
                                {item.delivery_challan_code}
                              </td>
                              <td className="px-4 py-2 border">
                                {item.itemname}
                              </td>
                              <td className="px-4 py-2 border">
                                {item.used_quantity_of_delivery_challan_item}
                              </td>

                              <td className="px-4 py-2 border">
                                <input
                                  type="number"
                                  required={item.isactive}
                                  min={
                                    -item.used_quantity_of_delivery_challan_item
                                  }
                                  max={
                                    item.initial_quantity -
                                    item.sales_order_moved_quantity
                                  }
                                  className="w-full p-1 border rounded"
                                  value={item.quantity}
                                  onChange={(e) =>
                                    handleQuantityChange(
                                      e,
                                      item.delivery_challan_item_id
                                    )
                                  }
                                  disabled={!item.isactive}
                                />
                                {/* <input
                                  type="number"
                                  required={item.isactive}
                                  min={-item.sales_order_moved_quantity}
                                  max={
                                    item.initial_quantity -
                                    item.sales_order_moved_quantity
                                  }
                                  className="w-full p-1 border rounded"
                                  value={item.quantity}
                                  onChange={(e) => {
                                    const input = e.target;
                                    const value = parseFloat(input.value);
                                    const min = parseFloat(input.min);
                                    const max = parseFloat(input.max);

                                    if (value < min) {
                                      input.setCustomValidity(
                                        `Quantity cannot be less than ${min}`
                                      );
                                    } else if (value > max) {
                                      input.setCustomValidity(
                                        `Quantity cannot be more than ${max}`
                                      );
                                    } else {
                                      input.setCustomValidity(""); // Clear the custom message
                                    }

                                    handleQuantityChange(
                                      e,
                                      item.delivery_challan_item_id
                                    );
                                  }}
                                  onInput={(e) =>
                                    e.target.setCustomValidity("")
                                  } // Reset validity on input
                                  disabled={!item.isactive}
                                /> */}
                              </td>
                              <td className="px-4 py-2 border">
                                {item.sales_order_moved_quantity}
                              </td>
                              <td className="px-4 py-2 border">
                                {item.initial_quantity}
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </Modal>
      ) : (
        <p className="text-xl font-medium">No permission to view this page.</p>
      )}
      <ToastContainer />
    </div>
  );
};

export default SalesOrderDeliveryChallanItemEdit;
